import { Component, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Getdatos from "../../../services/getDatos";

export default function Tematicas({
  caractFiltro,
  element,
  handleChange,
  nameCombo,
  changeSearchSetVal,
  idTematica,
}) {
  if (element === 0) {
    return (
      <>
        <Form.Select
          className="select-secciones focus-temticas"
          name={nameCombo}
          onChange={(e) => {
            changeSearchSetVal(e, "horizontal", element, 2);
          }}
        >
          <option value={"-1"}>Temáticas</option>
          {caractFiltro
            ? caractFiltro.resultTematicas.map((e, i) => {
                return (
                  <option key={e.id_tematica} value={e.id_tematica}>
                    {e.nombre}
                  </option>
                );
              })
            : ""}
        </Form.Select>
      </>
    );
  }
  if (element !== 0) {
    return (
      <>
        <Form.Select
          className="inputs-forms-admin focus-admin-register"
          onChange={handleChange}
          name={nameCombo}
          value={idTematica}
        >
          <option>Seleccione...</option>
          {caractFiltro
            ? caractFiltro.resultTematicas.map((e, i) => {
                return (
                  <option key={e.id_tematica} value={e.id_tematica}>
                    {e.nombre}
                  </option>
                );
              })
            : ""}
        </Form.Select>
      </>
    );
  }
}
